import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaInformacionCotizacion', {
    template: template,
    controller: NominasNominaInformacionCotizacionComponent,
    bindings: {
      data: '<',
    },
  })

function NominasNominaInformacionCotizacionComponent() {
  let $ctrl = this,
    data
  $ctrl.$onInit = $onInit
  $ctrl.cambiarModalidad = cambiarModalidad
  $ctrl.$onChanges = $onChanges

  function $onInit() {
    $ctrl.modalidad = 'todos'
  }

  function $onChanges(changes) {
    if (changes.data) {
      data = angular.copy(changes.data.currentValue)
      cambiarModalidad()
    }
  }

  function cambiarModalidad() {
    switch ($ctrl.modalidad) {
      case 'todos':
        $ctrl.data = {
          suministro: data.Suministro,
          carga_social: data.Carga_Social,
          impuesto_estatal: data.impuesto_estatal,
          comision_importe: data.Comision_Importe_SA,
          comision_porcentaje: data.Comision_Porcentaje_SA,
          subtotal: data.Subtotal_SA,
          iva: data.IVA_SA,
          total: data.Total_SA,
        }
        break
      case 'remunerados':
        $ctrl.data = {
          suministro: data.Suministro,
          carga_social: data.Carga_Social - data.Carga_Social_No_Remunerados,
          impuesto_estatal: data.impuesto_estatal,
          comision_importe: data.Comision_Importe_SA,
          comision_porcentaje: data.Comision_Porcentaje_SA,
          subtotal: data.Subtotal_SA - data.Subtotal_No_Remunerados,
          iva: data.IVA_SA - data.IVA_No_Remunerados,
          total: data.Total_SA - data.Total_No_Remunerados,
        }
        break
      case 'noremunerados':
        $ctrl.data = {
          suministro: 0,
          carga_social: data.Carga_Social_No_Remunerados,
          impuesto_estatal: 0,
          comision_importe: 0,
          comision_porcentaje: 0,
          subtotal: data.Subtotal_No_Remunerados,
          iva: data.IVA_No_Remunerados,
          total: data.Total_No_Remunerados,
        }
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/cotizacion/component.js